const state = {
  // Список промокодов
  promocodes: [],

  // Общее количество промокодов
  total: 0,

  // Флаг показывающий загружается ли сейчас страница с промокодами
  isLoading: false,
};

export default state;
